import Captcha from "react-canvas-captcha";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Space } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AppButton, AppForm, AppModal, AppText, AppTitle, FormInput } from "@/shared/Components";
import { ReloadIcon } from "@/shared/icons";
import { getCaptchaSchema } from "../model/schema";
import styles from "./style.module.scss";

type Props = {
  isOpen: boolean;
  onSubmit: () => void;
};

export const CaptchaModal = ({ isOpen, onSubmit }: Props) => {
  const { t } = useTranslation();
  const [generatedCaptcha, setGeneratedCaptcha] = useState("");
  const [captchaKey, setCaptchaKey] = useState(0);

  const formApi = useForm({
    resolver: yupResolver(getCaptchaSchema(generatedCaptcha)),
  });

  const refreshCaptcha = () => {
    formApi.reset();
    setCaptchaKey((prevKey) => prevKey + 1);
  };

  const handleSubmit = () => {
    onSubmit();
  };

  const footer = (
    <Flex justify="space-between" className={styles.footer}>
      <AppButton type="link" onClick={refreshCaptcha} icon={<ReloadIcon />}>
        {t("registrationPage.captcha.update")}
      </AppButton>
      <AppButton onClick={formApi.handleSubmit(handleSubmit)}>
        {t("registrationPage.captcha.confirm")}
      </AppButton>
    </Flex>
  );

  return (
    <AppModal
      centered
      className={styles["captcha-modal"]}
      footer={footer}
      open={isOpen}
      destroyOnClose
    >
      <Flex gap={16} vertical>
        <Space direction="vertical">
          <AppTitle level={3} className={styles.title}>
            {t("registrationPage.captcha.title")}
          </AppTitle>
          <AppText className={styles.subtitle}>{t("registrationPage.captcha.subtitle")}</AppText>
        </Space>
        <Captcha
          key={captchaKey}
          boxHeight={80}
          boxWidth={352}
          captchaConfig={{
            numberOfChars: 6,
            font: "bold 23px Arial",
            textStartingX: 90,
            textStartingY: 0,
          }}
          caseType="lowercase"
          setCode={(captchaCode: string) => setGeneratedCaptcha(captchaCode)}
        />
        <AppForm formApi={formApi} onSubmit={onSubmit}>
          <FormInput
            className={styles["registration-input"]}
            name={"captcha"}
            placeholder={t("registrationPage.captcha.inputPlaceholder")}
          />
        </AppForm>
      </Flex>
    </AppModal>
  );
};
